(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["worthy-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const link=event.target.closest('[data-worthy-size-link]');if(!link)return;const details=document.getElementById(link.hash.slice(1));if(details){details.open=true;details.querySelector('summary').focus({preventScroll:true});}});
  } catch(e) { console.error(e); }
})();

})();
